import React from 'react'
import Navbar from '../inc/Navbar'
import Boxkhat from './Boxkhat'
import {Link} from "react-router-dom";

function Boxkhatpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <div className="album py-1">
        
                  <div className="container">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li   className="breadcrumb-item"><Link style={{color:"black"}}  to="/"> Home</Link></li>

                        <li className="breadcrumb-item active" aria-current="page">Box Khat</li>
                      </ol>
                    </nav>
                  </div>
        
                </div>
        <Boxkhat/>
        
    </div>
  )
}

export default Boxkhatpage